import { Container, ProgressMeter, PBNumber } from "./styles";

const ProgressBar = ({ progress, status }) => {
  function selectColor(status) {
    if (status === "Em dia" || status === "Concluido") {
      return "#49B446";
    }
    if (status === "Em risco") {
      return "#ECCB57";
    }
    return "#EB5757";
  }

  return (
    <Container>
      <ProgressMeter
        progress={progress}
        width={progress + "%"}
        color={selectColor(status)}
      />
      <PBNumber>{progress.toFixed(2)}%</PBNumber>
    </Container>
  );
};

export default ProgressBar;
